<template>
  <!--询盘服务-->
  <div class="ab-leads">
    <div class="ab-leads-header flex-row">
      <div class="ab-banner-header flex-col">
        <MainNav />
        <div class="ab-banner-info warp">
          <div class="ab-banner-name fontsize32" data-aos="fade-down">
            <span>线索系列</span>
            <em></em>
          </div>
          <div
            class="ab-banner-name fontsize50"
            data-aos="fade-down"
            data-aos-delay="100"
          >
            <span>全球企业大数据模型</span>
            <em></em>
          </div>
          <div
            class="ab-banner-desc fontsize20"
            data-aos="fade-down"
            data-aos-delay="100"
          >
            <a
              @click="showModal"
              data-source="p"
              onmouseover="linkDataSource(this)"
              a-type="register"
              target="_blank"
              >免费注册体验，企业认证可获得额外积分</a
            >
            <!-- <a href="">新人特惠</a>
            <a  @click="showModal"  data-source="p"  onmouseover="linkDataSource(this)"    a-type="register"   target="_blank">注册领取</a> -->
          </div>
          <div class="ab-banner-btn" data-aos="fade-down" data-aos-delay="200">
            <Abbutton
              ><a
                @click="showModal"
                data-source="p"
                onmouseover="linkDataSource(this)"
                a-type="register"
                target="_blank"
                >立即试用</a
              ></Abbutton
            >
          </div>
        </div>
      </div>
    </div>

    <div class="leads-product-features">
      <AbBlock title="构建数据营销闭环" subTitle="拓客利器攻破获客难题">
        <div class="warp">
          <div class="fontsize22">智能监控追踪</div>
          <div class="fontsize22 lesds-product-f-19">AI精准定向</div>
          <div class="lesds-product-f-1">
            <div class="lesds_1">
              <img src="~@/assets/product/leads_2.png" alt="" />
            </div>
            <div class="lesds_2">
              <img src="~@/assets/product/leads_2.png" alt="" />
            </div>
            <div class="lesds-product-f-2">
              <a-row :gutter="[0, 35]">
                <a-col :xl="8" :xs="7">
                  <!-- <router-link to="/product/customer-recommend"> -->
                  <div class="fontsize22"><em></em>客户推荐</div>
                  <!-- </router-link> -->
                </a-col>
                <a-col :xl="8" :xs="7">
                  <!-- <router-link to="/product/intelligent-search"> -->
                  <div class="fontsize22"><em></em>客户智搜</div>
                  <!-- </router-link> -->
                </a-col>
                <a-col :xl="8" :xs="7">
                  <!-- <router-link to="/product/search-customer"> -->
                  <div class="fontsize22"><em></em>搜邮寻客</div>
                  <!-- </router-link> -->
                </a-col>
                <a-col :xl="8" :xs="7">
                  <!-- <a
                     @click="showModal"  data-source="p"  onmouseover="linkDataSource(this)"    a-type="register" 
                    target="_blank"
                  > -->
                  <div class="fontsize22"><em></em>客户动态</div>
                  <!-- </a> -->
                </a-col>
                <a-col :xl="8" :xs="7">
                  <!-- <router-link to="/product/customer-leads"> -->
                  <div class="fontsize22"><em></em>商机挖掘</div>
                  <!-- </router-link> -->
                </a-col>
                <a-col :xl="8" :xs="7">
                  <!-- <router-link to="/product/customs"> -->
                  <div class="fontsize22"><em></em>海关数据</div>
                  <!-- </router-link> -->
                </a-col>
              </a-row>
            </div>
            <div class="clearfix"></div>
            <div class="lesds-product-f-3">
              <div class="lesds-product-f-4">
                <img src="~@/assets/product/leads_7.png" alt="" />
              </div>
              <div class="lesds-product-f-5">
                <img src="~@/assets/product/leads_6.png" alt="" />
              </div>

              <div class="lesds-product-f-4 lesds-product-f-8">
                <img src="~@/assets/product/leads_7.png" alt="" />
              </div>
              <div class="lesds-product-f-5 lesds-product-f-9">
                <img src="~@/assets/product/leads_6.png" alt="" />
              </div>
              <a-row>
                <a-col :xl="4" :xs="4">
                  <ul>
                    <li>
                      <div>
                        <em></em>
                        <span class="fontsize18">目标市场商情调研</span>
                      </div>
                    </li>
                    <li>
                      <div>
                        <em></em>
                        <span class="fontsize18">目标客户贸易轨迹</span>
                      </div>
                    </li>
                    <li>
                      <div>
                        <em></em>
                        <span class="fontsize18">目标客户网络关系</span>
                      </div>
                    </li>
                  </ul>
                </a-col>
                <a-col :xl="5" :xs="5">
                  <div
                    class="lesds-product-f-6 fontsize18"
                    data-aos="flip-left"
                    data-aos-delay="200"
                  >
                    数据洞察
                  </div>
                </a-col>
                <a-col :xl="6" :xs="6">
                  <div
                    class="lesds-product-f-7"
                    data-aos="zoom-in"
                    data-aos-delay="300"
                  >
                    <div class="lesds-product-f-12"></div>
                    <div class="lesds-product-f-13"></div>
                    <div class="lesds-product-f-14 fontsize24">数据营销</div>
                    <div class="lesds-product-f-15 fontsize18">数据整合</div>
                    <div class="lesds-product-f-16 fontsize18">可视化数据</div>
                    <div class="lesds-product-f-17 fontsize18">数据模型</div>
                    <div class="lesds-product-f-18 fontsize18">数据采集</div>
                  </div>
                </a-col>
                <a-col :xl="5" :xs="5"
                  ><div
                    class="lesds-product-f-6 fontsize18 lesds-product-f-10"
                    data-aos="flip-left"
                    data-aos-delay="200"
                  >
                    数据分析
                  </div></a-col
                >
                <a-col :xl="4" :xs="4">
                  <ul class="lesds-product-f-11">
                    <li>
                      <div>
                        <em></em> <span class="fontsize18">效果量化分析</span>
                      </div>
                    </li>
                    <li>
                      <div>
                        <em></em> <span class="fontsize18">智能风险预判</span>
                      </div>
                    </li>
                    <li>
                      <div>
                        <em></em> <span class="fontsize18">BI经营决策</span>
                      </div>
                    </li>
                  </ul>
                </a-col>
              </a-row>
            </div>

            <div class="lesds-product-f-20">
              <ul>
                <li>
                  <div class="fontsize22">海关数据</div>
                  <span>进口订单</span>
                  <span>出口订单</span>
                  <span>贸易总览</span>
                </li>
                <li>
                  <div class="fontsize22">客户智搜</div>
                  <span>企业存续状态</span>
                  <span>工商信息</span>
                  <span>企业决策链</span>
                </li>
                <li>
                  <div class="fontsize22">搜邮寻客</div>
                  <span>公司邮箱</span>
                  <span>联系人邮箱</span>
                  <span>邮箱核验</span>
                </li>
                <li>
                  <div class="fontsize22">客户推荐</div>
                  <span>精准推荐</span>
                  <span>高质量客户</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </AbBlock>
    </div>

    <!--行业列表-->
    <div class="leads_scsj_bg">
      <div class="warp">
        <IndustryList></IndustryList>
      </div>
    </div>
    <!--问题列表-->

    <QuestionList v-bind="questionData"></QuestionList>
    <!--已服务列表-->
    <CustomerList></CustomerList>

    <FooterBanner></FooterBanner>
    <inquiry-modal-vue
      :visible="visible"
      @cancel="handleCancel"
    ></inquiry-modal-vue>
  </div>
</template>

<script>
import MainNav from "@/components/MainNav.vue";
import Abbutton from "@/components/Abbutton.vue";
import AbBlock from "@/components/AbBlock.vue";
import QuestionList from "@/components/QuestionList.vue";
import CustomerList from "@/components/CustomerList.vue";
import FooterBanner from "@/components/FooterBanner.vue";
import IndustryList from "./CustomerLeads/IndustryList.vue";
import metaInfo from "@/metaInfo";
import inquiryModalVue from "@/components/InquiryModal2.vue";
export default {
  metaInfo: metaInfo["customer-leads"],
  components: {
    MainNav,
    Abbutton,
    IndustryList,
    QuestionList,
    CustomerList,
    AbBlock,
    FooterBanner,
    inquiryModalVue,
  },
  data() {
    return {
      questionData: {
        blockTitle: "常见问题",
        blockSubTitle: "帮助客户快速解决问题",
        listData: [
          {
            q: "外贸人如何选择适合自己的数据产品？",
            a:
              "每款数据产品的应用场景及需求点不同，例如：通过海关数据可以查询相关公司的进出口贸易来往记录及详细的提单等信息；通过搜邮寻客可以查询到相关公司的管理者联系邮箱、社交主页等信息；通过客户智搜可以查询到企业存续状态、背景信息及组织架构等信息，外贸人可以根据实际需求出发选购产品，也可以联系在线客服获取产品推荐。",
          },
          {
            q: "数据产品可以单独选购或者自由组合选购吗？",
            a:
              "数据产品是可以单独选购的，每款数据产品又分为不同的应用版本，且每款产品的资费不同，外贸企业可以根据实际需求选购；若需需要获得更多的数据产品支持，可以自由组合选购产品。",
          },
          {
            q: "选购了海关数据还有必要选购搜邮寻客或其他数据产品吗？",
            a:
              "官方建议企业选购海关数据产品的同时也有必要选择搜邮寻客或者其他数据产品组合应用。每款数据产品着眼点与核心价值不同，产品组合应用的意义在于是为了通过每个产品查询到的信息更具有全面性和延展性，以便满足客户对数据的强烈需求。",
          },
          {
            q: "数据产品是如何计费的？",
            a:
              "提供的每款数据产品都分为不同的版本应用，其不同的版本套餐不仅费用不同且所包含的积分/当日查询权限也有所不同，总体资费相比市面其他类型产品性价比更占有优势，详情资费可咨询在线客户获取，服务期间支持版本升级。",
          },
        ],
      },
      visible: false,
    };
  },
  methods: {
    showModal() {
      usePageTracker().openInNewTab(
        "https://crm.cnabke.com/#/passport/register"
      );
      // window.open("https://crm.cnabke.com/#/passport/register", "_blank");
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.ab-leads{
  .leads_scsj_bg{
    background:#F7F8FC
  }
  .leads-product-features{
    padding-top: 55px;
    padding-bottom: 80px;
    .warp{
      height: 796px;
      position: relative;
      border-radius: 398px;
      border:30px dashed rgba(25, 139, 255, .03);
      margin-top:65px;
      .lesds-product-f-19.fontsize22{
        bottom:-31px;
        position: absolute;
        left:50%;
        margin:0px;
        margin-left:-100px;
      }
      .lesds-product-f-7{
        height:320px;
        width:320px;
        border:3px solid #fff;
        background:#8ec2fe;
        border-radius: 50%;
         margin-top: 54px;
           margin-left: -1px;
           position: relative;
           .lesds-product-f-15,.lesds-product-f-16,.lesds-product-f-17,.lesds-product-f-18{
            color:#fff;
            position: absolute;
            transform: rotate(45deg);
            top: 225px;
            left: 36px;
           }
           .lesds-product-f-16{
                 left: 194px;
                transform: rotate(-45deg);
           }
            .lesds-product-f-17{
              left: 204px;
              top: 64px;
              transform: rotate(45deg);
           }
           .lesds-product-f-18{
              left: 34px;
              top: 64px;
              transform: rotate(-45deg);
           }
           .lesds-product-f-12,.lesds-product-f-13{
              width:320px;
              height:6px;
              background:#fff;
              top:157px;left:-4px;position: absolute;

           }
           .lesds-product-f-14{
            width:165px;
            height:165px;
            background:#fff;line-height: 165px;
            text-align:center; border-radius: 50%;
            margin-left: 73px;
            margin-top: 76px;    z-index: 2;
            position: relative;
           }
           .lesds-product-f-13{
            transform: rotate(90deg);
                top: 153px;
           }
      }
      .lesds-product-f-6{
        width: 140px;
        height: 140px;
        background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
        color:#fff;
        line-height:140px;
        text-align:center;
        border-radius: 50%;
        margin-top: 144px;
        margin-left: 18px;
        font-family: AlibabaPuHuiTiM, Alibaba-PuHuiTi;

      }
      .lesds-product-f-10{
        margin-left:104px;
      }
      .lesds-product-f-3{
        position: relative;
        .lesds-product-f-4{
          position: absolute;
          left: 61px;
        }
        .lesds-product-f-8{
          right:61px;
          transform: rotate(180deg);
          left:initial;
          top:5px;
        }

        .lesds-product-f-5{
             position: absolute;
            left: -185px;

        }
         .lesds-product-f-9{
          left:initial;
          right:-136px;    margin-top: 9px;
          transform: rotate(180deg);
        }

        ul{
          padding-top:139px;
          left: -22px;
          position: relative;
        }
         ul.lesds-product-f-11{
          li{
            text-indent:20px;
          }
          left:10px;
        }

        ul.lesds-product-f-11 li:nth-child(2){
            margin-left:25px;
        }
        li:nth-child(1),li:nth-child(3){
          margin-left:12px;
        }

        li{
          div{
            &:hover em{
              background:#fff;
            }
            &:hover{
              background:#198BFF;
              color:#fff;
            }
            width: 200px;
            height: 36px;
            line-height:36px;
            background: #FFFFFF;
            border-radius: 18px;
            display:block;
            padding-left:15px;
            margin:12px 0px;
            em{
              width: 6px;
              height: 6px;
              display: inline-block;
              position: relative;
              margin-right:3px;
              top:-3px;
                border-radius: 50%;
              background:#198BFF;
            }
          }
        }
      }
      .lesds-product-f-2{
        .fontsize22{
          em{border-radius: 50%;
            width: 6px;
            height: 6px;
            background: #198BFF;
            top: 19px;
            left: 42px;
            display:block;
            position: relative;

          }
        }
        width:500px;
        margin:60px auto 0px auto;
      }
      .lesds_1,.lesds_2{
        position: absolute;

      }
      .lesds_1{
        transform:rotate(35deg);
        left:400px;top: 25px;

      }
      .lesds_2{
       transform: rotate(-168deg);
        right: 295px;
        bottom: 45px;

      }

      .lesds-product-f-1{
        height: 690px;
        border-radius: 339px;
        border: 8px solid rgba(25, 139, 255, 0.1);
        margin:0px auto;
        margin-top:30px;
        width: 1273px;
        .lesds-product-f-20{
          width:644px;
          margin:0px auto;
          background: url('~@/assets/product/leads_1.png') no-repeat top center;
          height:220px;
          position: relative;
          padding-top:30px;
         top:-30px;
          .fontsize22{
            width:auto;
            margin:0px;
          }
          li:nth-child(1){
            position: relative;
            left:-72px;
          }
          li:nth-child(2){
            position: relative;
            top: 44px;
            left: -12px;
          }
          li:nth-child(3){
            position: relative;
            top: 44px;
            left: 10px;
          }
           li:nth-child(4){
            position: relative;

            left: 74px;
          }
          li{
            width:25%;
            float: left;
            text-align:center;
            div{
              padding-bottom:1px;
            }
            span{
              &:hover{
               color: #1890ff
              }
              display:block;
              font-size:16px;
              color:#666;
              margin:2px 0px;
            }
          }
        }
      }
      .fontsize22{
        width:200px;text-align:center;
        margin:0px auto;
        margin-top: -32px;
      }
    }

  }
  ::v-deep .ab-question .q-list .q-item .q-block {
      height: 7rem;
      padding-bottom:0px;
  }
}

.ab-leads-header {
  height:620px;
  background: url('~@/assets/images/banner_客户线索.jpg') no-repeat;
  background-size:cover;
  .ab-banner-header {
  width: 100%;
  height: 100%;
  .ab-banner-info{
    padding-top:74px;
    padding-left:145px;
    .ab-banner-name.fontsize32,.ab-banner-name.fontsize50{
      span{
         z-index: 2;
         position: relative
      }
      em{
        width: 151px;
height: 10px;    display: block;
background: linear-gradient(90deg, #FFAEAE 0%, rgba(255,174,174,0) 100%);
position:absolute;    bottom: 16px;
    z-index: 1;    left: -3px;
      }
    }
    .ab-banner-name.fontsize50  em{
       bottom: 10px;
    }
    .ab-banner-name{
      position: relative;
      height: 69px;
      font-family: AlibabaPuHuiTiM;
      color: #333646;
      line-height: 69px;
    }

    .ab-banner-desc{
      width: 549px;
      margin-bottom:45px;
      font-family: Alibaba-PuHuiTi-R;
      font-weight: normal;
      color: rgba(51,51,51,0.4);
      line-height: 36px;
      padding-top: 27px;

      a{
        &:hover{
           background: rgba(255,255,255,0.7);
        }
        padding:0px 15px;
        line-height: 36px;
        text-align:center;
        font-size:18px;
        color:#2B68FF;
        margin-right:10px;
        display: inline-block;
        background: rgba(255,255,255,0.3);

      }
    }
    .ab-banner-btn{
      width:200px;
    }
  }
}

}
</style>
